import React from 'react';

const Badge = ({
  children,
  variant = 'neutral',
  size = 'md',
  className = '',
  ...props
}) => {
  const variantClasses = {
    primary: 'bg-primary-100 text-primary-700 border border-primary-200',
    success: 'bg-success-100 text-success-700 border border-success-200',
    danger: 'bg-danger-100 text-danger-700 border border-danger-200',
    warning: 'bg-warning-100 text-warning-700 border border-warning-200',
    info: 'bg-info-100 text-info-700 border border-info-200',
    neutral: 'bg-neutral-100 text-neutral-700 border border-neutral-200',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base',
  };

  return (
    <span
      className={`inline-flex items-center gap-1 font-semibold rounded-full ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
